export default "__VITE_ASSET__DLSTbVIE__"